import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Badge } from "../../../../../components/tailwind/badge";
import { Button } from "../../../../../components/tailwind/button";
import { workflowTheme } from "../../../utils/workflowBuilderTheme";
import { WhatsAppPageIntro } from "../../WhatsAppPageIntro";

export function WorkflowAnalyticsHeader({ monthLabel, liveSessionCount }) {
  const navigate = useNavigate();

  return (
    <div className="flex items-start gap-3 md:gap-4">
      <Button
        type="button"
        variant="ghost"
        size="icon"
        className={`shrink-0 ${workflowTheme.backIconButton}`}
        onClick={() => navigate("/whatsapp/workflows")}
        aria-label="Back to workflows"
      >
        <ArrowLeft className="h-4 w-4 md:h-5 md:w-5" />
      </Button>
      <WhatsAppPageIntro
        description={`Session funnel and node performance for ${monthLabel}.`}
        className="flex-1 !animate-none"
        actions={
          <Badge
            variant="secondary"
            className="border-none bg-green-50 text-green-700 dark:bg-green-950/40 dark:text-green-400 hover:bg-green-50 dark:hover:bg-green-950/40 px-2.5 md:px-3 py-1 text-xs md:text-sm font-medium gap-1.5 md:gap-2"
          >
            <span className="w-1.5 h-1.5 md:w-2 md:h-2 rounded-full bg-green-500 animate-pulse" />
            {liveSessionCount} Live Sessions
          </Badge>
        }
      />
    </div>
  );
}
